// extracted by mini-css-extract-plugin
module.exports = {"carouselSlide":"Carousel_carouselSlide__OfnOJ","carouselDefault":"Carousel_carouselDefault__0KWo1"};